import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {AuthService} from '../../services/Auth'
import {Block, Col} from 'jsxstyle'
import Loader from '../Loader'
import {useXpertKnowledgeAuthContext} from './XpertKnowledgeAuthContext'
import {deleteCookie, getCookieName} from '../../common/utils/cookieUtils'

const SSOXpertKnowledge = () => {
  const {token} = useParams<{token: string}>()
  const navigate = useNavigate()
  const {login} = useXpertKnowledgeAuthContext()

  useEffect(() => {
    const authenticate = async () => {
      try {
        if (!token) {
          throw new Error('No token provided')
        }

        deleteCookie(getCookieName())
        await login(token)
        navigate('/xpert-knowledge')
      } catch (error) {
        console.error('Error during SSO authentication:', error)
        navigate('/xpert-knowledge/error')
      }
    }

    if (token) {
      authenticate()
    }
  }, [token, navigate])

  return (
    <Block width="100vw" height="100vh" display="flex" justifyContent="center" alignItems="center">
      <Col gap="10px" justifyContent="center" alignItems="center" textAlign="center">
        <Loader size={75} />
        <Block fontWeight={500} lineHeight="60px" fontSize="34px">
          Authentication in progress...
        </Block>
      </Col>
    </Block>
  )
}

export default SSOXpertKnowledge
